/** @format */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  ProgressBar,
  ButtonGroup,
  InputGroup,
  Badge,
} from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Import the phone input styles

import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const UserSignUpForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [skills, setSkills] = useState(["Adobe Photoshop"]);
  const [newSkill, setNewSkill] = useState("");
  const [countries, setCountries] = useState([]);
  const nav = useNavigate();

  const handleAddSkill = () => {
    if (newSkill.trim() && !skills.includes(newSkill)) {
      setSkills([...skills, newSkill.trim()]);
      setNewSkill("");
    }
  };

  const handleRemoveSkill = (skillToRemove) => {
    setSkills(skills.filter((skill) => skill !== skillToRemove));
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (phone) => {
    setFormData({ ...formData, phoneNumber: phone });
  };

  const handleSubmit = (event) => {
    // event.preventDefault();
    nav("/auth/otp");
  };

  console.log("step:", step);
  useEffect(() => {
    const fetchCountries = async () => {
      const response = await fetch("https://restcountries.com/v3.1/all");
      const data = await response.json();
      const countryOptions = data.map((country) => ({
        value: country.name.common,
        label: country.name.common,
      }));
      setCountries(countryOptions);
    };

    fetchCountries();
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <ProgressBar now={(step / 3) * 100} variant="success" />
        <br />
        {step === 1 && (
          <>
            <Form.Group controlId="formStep1" className="form-group text-start">
              <Form.Label className="form-label fw-bold">First Name</Form.Label>
              <Form.Control
                type="text"
                name="first_name"
                value={formData.first_name || ""}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group
              controlId="formStep1_1"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Last Name</Form.Label>
              <Form.Control
                type="text"
                name="last_name"
                value={formData.last_name || ""}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group
              controlId="formStep1_2"
              className="form-group text-start"
            >
              <Form.Label className=" fw-bold">Status</Form.Label>
              <ButtonGroup className="d-flex">
                <Button
                  variant={
                    formData.status === "student"
                      ? "primary"
                      : "outline-primary"
                  }
                  className="me-2 d-flex align-items-center"
                  onClick={() =>
                    handleInputChange({
                      target: { name: "status", value: "student" },
                    })
                  }
                  style={{
                    backgroundColor:
                      formData.status === "student" ? "#6f42c1" : "transparent",
                    borderColor: "#6f42c1",
                    color: formData.status === "student" ? "#fff" : "#6f42c1",
                    fontSize: "1.25rem",
                    padding: "0.75rem 1.5rem",
                    borderWidth: "2px",
                  }}
                >
                  <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                  I’m Student
                </Button>
                <Button
                  variant={
                    formData.status === "working"
                      ? "success"
                      : "outline-success"
                  }
                  className="d-flex align-items-center"
                  onClick={() =>
                    handleInputChange({
                      target: { name: "status", value: "working" },
                    })
                  }
                  style={{
                    backgroundColor:
                      formData.status === "working" ? "#20c997" : "transparent",
                    borderColor: "#20c997",
                    color: formData.status === "working" ? "#fff" : "#20c997",
                    fontSize: "1.25rem",
                    padding: "0.75rem 1.5rem",
                    borderWidth: "2px",
                  }}
                >
                  <FontAwesomeIcon icon={faBriefcase} className="me-2" />
                  Looking for Job
                </Button>
              </ButtonGroup>
            </Form.Group>
          </>
        )}
        {step === 2 && (
          <>
            <Form.Group
              controlId="formPhoneNumber"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">Phone Number</Form.Label>
              <PhoneInput
                country={"my"} // Set default country as Malaysia
                value={formData.phoneNumber || ""}
                onChange={handlePhoneChange}
                inputProps={{
                  name: "phoneNumber",
                  required: true,
                  autoFocus: true,
                }}
                inputStyle={{
                  width: "100%", // Ensures the input takes up full width
                }}
                containerClass="custom-phone-input"
              />
            </Form.Group>
            <Form.Group
              controlId="formCountry"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">Country</Form.Label>
              <Form.Control
                as="select"
                name="country"
                value={formData.country || ""}
                onChange={handleInputChange}
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group
              controlId="formJobPosition"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">
                Position Job You Are Interested
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter job position"
                name="jobPosition"
                value={formData.jobPosition || ""}
                onChange={handleInputChange}
              />
            </Form.Group>
          </>
        )}
        {step === 3 && (
          <>
            <Form.Group
              controlId="formFile"
              className="mb-3 form-group text-start"
            >
              <Form.Label className="fw-bold">Upload Resume</Form.Label>
              <Form.Control type="file" />
            </Form.Group>
            <Form.Group
              controlId="formEducation"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">
                Your Highest Education
              </Form.Label>
              <Form.Control
                as="select"
                name="education"
                value={formData.education || ""}
                onChange={handleInputChange}
              >
                <option value="">Please select your level</option>
                <option value="SPM/O-Levels">SPM/O-Levels</option>
                <option value="Bachelor Degree">Bachelor Degree</option>
                <option value="Masters">Masters</option>
                <option value="PHD">PHD</option>
              </Form.Control>
            </Form.Group>
            <Form.Group
              controlId="formFieldOfStudy"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">Field of Study</Form.Label>
              <Form.Control
                type="text"
                placeholder="E.g Business"
                name="field_of_study"
                value={formData.field_of_study || ""}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group
              controlId="formSkills"
              className="form-group text-start"
            >
              <Form.Label className="fw-bold">Skills</Form.Label>
              <InputGroup>
                <div
                  className="skills-container"
                  style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                >
                  {skills.map((skill, index) => (
                    <Badge
                      key={index}
                      pill
                      bg="light"
                      text="dark"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {skill}
                      <Button
                        variant="link"
                        size="sm"
                        onClick={() => handleRemoveSkill(skill)}
                        style={{
                          marginLeft: "8px",
                          padding: "0",
                          lineHeight: "1",
                        }}
                      >
                        &times;
                      </Button>
                    </Badge>
                  ))}
                </div>
                <Form.Control
                  type="text"
                  placeholder="Add a skill"
                  value={newSkill}
                  onChange={(e) => setNewSkill(e.target.value)}
                />
                <Button variant="outline-success" onClick={handleAddSkill}>
                  <Plus />
                </Button>
              </InputGroup>
            </Form.Group>
          </>
        )}
        <ButtonGroup className="d-flex justify-content-between mt-4">
          {step > 1 && (
            <Button variant="secondary" onClick={handlePrevious}>
              Previous
            </Button>
          )}
          {step < 3 ? (
            <Button variant="success" onClick={handleNext}>
              Next
            </Button>
          ) : (
            <Button variant="success" type="button" onClick={handleSubmit}>
              Submit
            </Button>
          )}
        </ButtonGroup>
      </Form>
    </>
  );
};

export default UserSignUpForm;
